import { IconButton } from "@gfg/ui-v2/components/button";
import { TagProps } from "@gfg/ui-v2/components/tag";
import { RotateLeftIcon } from "@gfg/ui-v2/icons";

function UndoButton(props: { onClick?: TagProps["onClose"] }) {
  return <IconButton icon={RotateLeftIcon} round size="small" variant="link" {...props} />;
}

export default UndoButton;
